class CSVRecord {
    
    constructor(data) {
        this.data = data;
    }   
    
    length() {   
        return this.data.length;
    }
    
    getValue(i) {                      
        return this.data[i]; 
    }    
}

class CSVFile {
    
    constructor(result) {
        this.result = result;
    }
    
    getData() {
        return this.result.data.map(row => new CSVRecord(row));
    }
    
}


const csv = async (lines, delimiter, quoteChar) => {
	const { parse } = await import(/* webpackChunkName: "csv" */ 'papaparse/papaparse.js');
    const text = lines.join("\n");
    
    const options = {
         delimiter: delimiter,
         quoteChar: quoteChar
    };
    
    const result = parse(text, options);    
    return new CSVFile(result);
}

export {
	csv
}